// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__352fi","option":"styles_option__3Sd78","selected":"styles_selected__2-MWe"};